<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'cardPaymentConfig', params: {} }">
            Card Payment Config
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'cardPaymentConfigView', params: {} }">
              View Card Payment Config
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Card Payment Config
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="cardPaymentConfig.center">
            <td max-width="35%" class="text-subtitle-1">Center:</td>
            <td>
              {{ getRelationText(cardPaymentConfig.center, "center", "name") }}
            </td>
          </tr>
          
          <tr v-if="cardPaymentConfig.label">
            <td max-width="35%" class="text-subtitle-1">Label:</td>
            <td>{{ cardPaymentConfig.label }}</td>
          </tr>
          
          <tr v-if="cardPaymentConfig.transactionKey">
            <td max-width="35%" class="text-subtitle-1">Transaction Key:</td>
            <td>{{ cardPaymentConfig.transactionKey }}</td>
          </tr>
          
          <tr v-if="cardPaymentConfig.apiLogonId">
            <td max-width="35%" class="text-subtitle-1">API ID:</td>
            <td>{{ cardPaymentConfig.apiLogonId }}</td>
          </tr>
          
          <tr v-if="cardPaymentConfig.clientKey">
            <td max-width="35%" class="text-subtitle-1">Client Key:</td>
            <td>{{ cardPaymentConfig.clientKey }}</td>
          </tr>
          
          <tr v-if="cardPaymentConfig.acceptjsUrl">
            <td max-width="35%" class="text-subtitle-1">Accept JS URL:</td>
            <td>{{ cardPaymentConfig.acceptjsUrl }}</td>
          </tr>
          
          <tr v-if="cardPaymentConfig.paymentProcessor">
            <td max-width="35%" class="text-subtitle-1">Payment Processor:</td>
            <td>{{ cardPaymentConfig.paymentProcessor }}</td>
          </tr>
          
          <tr v-if="cardPaymentConfig.sandbox">
            <td max-width="35%" class="text-subtitle-1">Sandbox:</td>
            <td>{{ cardPaymentConfig.sandbox }}</td>
          </tr>
          
          <tr v-if="cardPaymentConfig.active">
            <td max-width="35%" class="text-subtitle-1">Active:</td>
            <td>{{ cardPaymentConfig.active }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getCardPaymentConfig } from "@/services/cardPaymentConfig";
    
              import { getAllLocations } from "@/services/location";
            

    export default {
      data() {
        return {
            id: '',
            cardPaymentConfig: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "cardPaymentConfigEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getCardPaymentConfig(this.id)
            .then((response) => {
              this.cardPaymentConfig = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading cardPaymentConfig");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          
            const params_center = {
              page: 0,
              size: 100
            };
            await getAllLocations(params_center)
              .then(response => {
                this.relations.center = response.data.content;
                return this.relations.center;
              });
            
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    